export default __webpack_public_path__ + "static/media/lagman.be391595.png";